var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wHeader'),_c('wSidebar'),_c('div',{staticClass:"wHome-main",class:{ isOpen: _vm.collapse }},[_c('transition',{attrs:{"name":"fade","appear":true,"mode":"out-in"}},[(_vm.isCrumbs)?[_c('router-view')]:[_c('wPageCrumbs',[_c('router-view')],1)]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }